import * as React from "react";

function SvgGoogleCloudStorage(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="1em"
      height="1em"
      viewBox="0 0 128 128"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="GoogleCloud_Storage_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={64}
        y1={7.034}
        x2={64}
        y2={120.789}
      >
        <stop offset={0} stopColor="#4387fd" />
        <stop offset={1} stopColor="#4683ea" />
      </linearGradient>
      <path
        d="M27.79 115.217L1.54 69.749a11.499 11.499 0 010-11.499l26.25-45.467a11.5 11.5 0 019.96-5.75h52.5a11.5 11.5 0 019.959 5.75l26.25 45.467a11.499 11.499 0 010 11.5l-26.25 45.467a11.5 11.5 0 01-9.959 5.749h-52.5a11.499 11.499 0 01-9.96-5.75z"
        fill="url(#GoogleCloud_Storage_svg__a)"
      />
      <defs>
        <path
          id="GoogleCloud_Storage_svg__b"
          d="M27.791 115.217L1.541 69.749a11.499 11.499 0 010-11.499l26.25-45.467a11.499 11.499 0 019.959-5.75h52.5a11.5 11.5 0 019.96 5.75l26.25 45.467a11.499 11.499 0 010 11.5l-26.25 45.467a11.499 11.499 0 01-9.96 5.749h-52.5a11.499 11.499 0 01-9.959-5.75z"
        />
      </defs>
      <clipPath id="GoogleCloud_Storage_svg__c">
        <use xlinkHref="#GoogleCloud_Storage_svg__b" overflow="visible" />
      </clipPath>
      <path
        opacity={0.07}
        clipPath="url(#GoogleCloud_Storage_svg__c)"
        d="M118.938 84l-33.45-33.45-36.175 3.325-7.01 6.99 5.957 5.958-5.898 10.476 44.635 44.636 10.816.002z"
      />
      <g>
        <g fill="#fff">
          <path d="M84.7 50.27H43.264c-.667 0-1.213.546-1.213 1.213l.001 8.566c0 .666.546 1.212 1.212 1.212h41.435c.667 0 1.213-.546 1.213-1.212v-8.567c0-.666-.545-1.213-1.212-1.213m-6.416 7.975a2.484 2.484 0 01-2.478-2.48 2.475 2.475 0 012.478-2.477 2.48 2.48 0 010 4.957M84.7 66.736l-41.436.001c-.667 0-1.213.547-1.213 1.215l.001 8.564c0 .666.546 1.213 1.212 1.213h41.435c.667 0 1.213-.547 1.213-1.213V67.95c0-.666-.545-1.214-1.212-1.214m-6.416 7.975a2.483 2.483 0 01-2.478-2.48 2.475 2.475 0 012.478-2.476 2.48 2.48 0 010 4.956" />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgGoogleCloudStorage);
